import { groupBy } from 'lodash';
import type { IntlShape } from 'react-intl';

import { testHasTextMatch } from '~/eds/src/utils/testHasTextMatch';

import { OptionsType } from './types';

export const groupFilterOptions = ({
  searchFilters,
  search,
  groupsOrder,
}: {
  searchFilters: OptionsType[];
  search: string;
  groupsOrder: string[];
}) => {
  const groups = groupBy(searchFilters, (filter) => filter.section);

  const mainGroups = groupsOrder.map((section) =>
    asCheckboxGroup(section, groups[section], search),
  );
  const additionalGroups = Object.keys(groups)
    .filter((section) => groupsOrder.indexOf(section) === -1)
    .map((section) => asCheckboxGroup(section, groups[section], search));

  return [...mainGroups, ...additionalGroups];
};

export const asCheckboxGroup = (
  section: string,
  group: OptionsType[],
  search: string,
) => {
  return {
    title: section,
    options: (group || []).map(asGroupItem).filter((groupOption) => {
      if (!search) return true;
      return testHasTextMatch(groupOption.label, search);
    }),
  };
};

export const asGroupItem = (searchFilter: OptionsType) => ({
  label: searchFilter.label,
  value: searchFilter.id,
  description: searchFilter.section,
});

export const getPresets = (intl: IntlShape) => {
  const buttonText = intl.formatMessage({
    id: 'ManageFilters.addFiltersButtonAction',
    defaultMessage: 'Add Filters',
    description: 'Button text for add filters action',
  });
  const ctaText = intl.formatMessage({
    id: 'ManageFilters.addCta',
    defaultMessage: 'Add',
    description: 'CTA text for add action',
  });

  const presets = {
    'add-filters-button': {
      buttonText,
      buttonVariant: 'primary' as const,
      ctaText,
      buttonIcon: 'filter' as const,
      buttonSize: 's' as const,
    },
    'add-filters': {
      buttonText,
      buttonVariant: 'action' as const,
      ctaText,
    },
    'edit-charts': {
      buttonText: intl.formatMessage({
        id: 'ManageFilters.editChartsButton',
        defaultMessage: 'Edit Charts',
        description: 'Button text for edit charts',
      }),
      buttonVariant: 'secondary' as const,
      ctaText: intl.formatMessage({
        id: 'ManageFilters.applyChangesCta',
        defaultMessage: 'Apply Changes',
        description: 'CTA text for apply changes action',
      }),
    },
  };
  return presets;
};
